import {withKnownRoute} from '../../lib/routes';
import {MonstersPage} from './monsters-page';

export default withKnownRoute(MonstersPage);
